export default __webpack_public_path__ + "static/media/new_tutorial_privilege_coupons_2x.742d76bd.webp";